import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import {
  GetProductCategoryListDropDownSlice,
  GetSubCategoryProductSlice,
} from "../../../redux/features/ProductCategorySlice";

import {
  GetMetaDataByIdSlice,
  UpdateMetaDataSlice,
  clearSelectedMetaData,
} from "../../../redux/features/MetaDataManagementSlice";

import Editor from "../../../common/Editor/Editor";

const EditMetaSubCategory = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { selectedMetaData, loading } = useSelector(
    (state) => state.MetaDataManagement
  );

  const [categoryList, setCategoryList] = useState([]);
  const [subcategoryList, setSubcategoryList] = useState([]);

  /* 🔹 FORM STATE */
  const [form, setForm] = useState({
    categoryId: "",
    subcategoryId: "",
    type: "SUBCATEGORY",
    title: "",
    description: "",
    keywords: "",
    content: "",
    status: "active",
  });

  /* =========================
     CATEGORY LIST
  ========================== */
  useEffect(() => {
    dispatch(GetProductCategoryListDropDownSlice()).then((res) => {
      setCategoryList(res?.payload?.data || []);
    });
  }, [dispatch]);

  /* =========================
     FETCH META DATA BY ID
  ========================== */
  useEffect(() => {
    if (id) {
      dispatch(clearSelectedMetaData());
      dispatch(GetMetaDataByIdSlice(id));
    }
  }, [id, dispatch]);

  /* =========================
     PREFILL FORM
  ========================== */
  useEffect(() => {
    if (selectedMetaData && selectedMetaData._id === id) {
      setForm({
        categoryId: selectedMetaData.categoryId?._id || "",
        subcategoryId: selectedMetaData.subcategoryId?._id || "",
        type: "SUBCATEGORY",
        title: selectedMetaData.title || "",
        description: selectedMetaData.description || "",
        keywords: selectedMetaData.keywords?.join(", ") || "",
        content: selectedMetaData.content || "",
        status: selectedMetaData.status || "active",
      });
    }
  }, [selectedMetaData, id]);

  /* =========================
     SUB CATEGORY LIST
  ========================== */
  useEffect(() => {
    if (form.categoryId) {
      dispatch(GetSubCategoryProductSlice(form.categoryId)).then((res) => {
        setSubcategoryList(res?.payload?.data?.subcategory || []);
      });
    }
  }, [form.categoryId, dispatch]);

  /* =========================
     CLEANUP
  ========================== */
  useEffect(() => {
    return () => {
      dispatch(clearSelectedMetaData());
    };
  }, [dispatch]);

  /* =========================
     HANDLERS
  ========================== */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    await dispatch(
      UpdateMetaDataSlice({
        id,
        payload: {
          ...form,
          keywords: form.keywords
            .split(",")
            .map((k) => k.trim())
            .filter(Boolean),
        },
      })
    );

    navigate("/MetadataManagement/SubCategoryMetaData");
  };

  /* =========================
     LOADER
  ========================== */
  if (loading || !selectedMetaData) {
    return <div className="text-center mt-5">Loading...</div>;
  }

  /* =========================
     UI
  ========================== */
  return (
    <div className="Small-Wrapper mt-4">
      {/* CATEGORY */}
      <div className="form-group">
        <label>Category</label>
        <select
          className="form-control"
          name="categoryId"
          value={form.categoryId}
          onChange={handleChange}
        >
          <option value="">-- Select Category --</option>
          {categoryList.map((cat) => (
            <option key={cat._id} value={cat._id}>
              {cat.categoryName}
            </option>
          ))}
        </select>
      </div>

      {/* SUB CATEGORY */}
      <div className="form-group">
        <label>SubCategory</label>
        <select
          className="form-control"
          name="subcategoryId"
          value={form.subcategoryId}
          onChange={handleChange}
          disabled={!subcategoryList.length}
        >
          <option value="">-- Select SubCategory --</option>
          {subcategoryList.map((sub) => (
            <option key={sub._id} value={sub._id}>
              {sub.subcategoryName}
            </option>
          ))}
        </select>
      </div>

      {/* TITLE */}
      <div className="form-group">
        <label>Title</label>
        <input
          className="form-control"
          name="title"
          value={form.title}
          onChange={handleChange}
        />
      </div>

      {/* DESCRIPTION */}
      <div className="form-group">
        <label>Description</label>
        <textarea
          className="form-control"
          name="description"
          value={form.description}
          onChange={handleChange}
        />
      </div>

      {/* KEYWORDS */}
      <div className="form-group">
        <label>Keywords</label>
        <input
          className="form-control"
          name="keywords"
          value={form.keywords}
          onChange={handleChange}
        />
      </div>

      {/* CONTENT */}
      <Editor
        setContentState={setForm}
        type="content"
        content={form.content}
        form={form}
      />

      <button className="Button mt-3" onClick={handleSubmit}>
        Update
      </button>
    </div>
  );
};

export default EditMetaSubCategory;
